/**
 * Stripe subscription statuses that grant full app access.
 * Keep in sync with subscription pick logic (e.g. sync-subscription route priority).
 *
 * - "active"   — subscription is current and paid
 * - "trialing" — in a free trial period
 * - "past_due" — renewal payment failed but Stripe is still retrying (Smart Retries).
 *                Users keep access during the grace/retry window instead of being
 *                immediately locked out.  The app should show a warning banner
 *                prompting the user to update their payment method.
 */
export function subscriptionStatusGrantsAccess(
  status: string | undefined | null,
): boolean {
  return status === "active" || status === "trialing" || status === "past_due";
}
